import PosthogService from '~/services/posthog/PosthogService';

/**
 * Fires when the user clicks "Invite" from the Shift Request flow
 * Event: dental_portal:shift_request:invite_clicked
 */
export function fireShiftRequestInviteClicked(): void {
  PosthogService.getInstance().track('dental_portal:shift_request:invite_clicked', {
    invite_type: 'New Shift',
  });
}
